var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"empresa-bloco-informacao"}},[_c('div',{staticClass:"bloco-informacao__interno"},[_c('span',[_vm._t("icone")],2),_c('span',{staticClass:"bloco-informacao__interno-texto"},[_vm._v(_vm._s(_vm.titulo))])]),_c('span',{staticClass:"bloco-informacao__interno-numero"},[_vm._v(_vm._s(_vm.numero)+" "+_vm._s(_vm.sigla))])])
}
var staticRenderFns = []

export { render, staticRenderFns }